import { createContext } from 'react';

export const RevokeDeviceContext = createContext();
export const RevokeDeviceDispatchContext = createContext();
